import { render, staticRenderFns } from "./TheoryExamine.vue?vue&type=template&id=a58a0756&scoped=true&"
import script from "./TheoryExamine.vue?vue&type=script&lang=js&"
export * from "./TheoryExamine.vue?vue&type=script&lang=js&"
import style0 from "./TheoryExamine.vue?vue&type=style&index=0&id=a58a0756&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58a0756",
  null
  
)

export default component.exports